import { apiGet, apiDelete, apiPostFile, apiGetBlob } from '../config/api';

export const getDocuments = (user) =>
  apiGet('/student-portal/documents', user);

export const uploadDocument = (user, file, category, slotName) => {
  const formData = new FormData();
  formData.append('files', file);
  formData.append('category', category);
  formData.append('slotName', slotName);
  return apiPostFile('/student-portal/documents/upload', user, formData);
};

export const deleteDocument = (user, docId) =>
  apiDelete(`/student-portal/documents/${docId}`, user);

export const viewDocument = (user, docId) =>
  apiGetBlob(`/student-portal/documents/${docId}/view`, user);

export const uploadCompleteCategoryPdf = (user, file, category) => {
  const formData = new FormData();
  formData.append('files', file);
  return apiPostFile(`/student-portal/documents/upload-complete-pdf/${category}`, user, formData);
};
